import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService, fromMinutesToMilliseconds, fromSecondsToMilliseconds } from "@obg/ngx.global";

import { NotificationsInfoRequest } from "./oms.model";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class OmsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointNotificationsActive(): string {
		return this.configService.get(
			(x) => x.common.content.oms?.endpoints!.notifications,
			"v1/oms/messages/notifications/active/"
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointNotificationsExpired(): string {
		return this.configService.get(
			(x) => x.common.content.oms?.endpoints!.notifications,
			"v1/oms/messages/notifications/expired/"
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointUpdateMessage(): string {
		return this.configService.get(
			(x) => x.common.content.oms?.endpoints!.updateMessage,
			"v1/oms/messages/notifications/:messageId/"
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointUpdateMessages(): string {
		return this.configService.get(
			(x) => x.common.content.oms?.endpoints!.updateMessages,
			"v1/oms/messages/notifications/"
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointAlerts(): string {
		return this.configService.get(
			(x) => x.common.content.oms?.endpoints!.alerts,
			"v1/oms/messages/alerts/:context/"
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointNotificationsInfo(): string {
		return this.configService.get(
			(x) => x.common.content.oms?.endpoints!.notificationsInfo,
			"v1/oms/notificationinfo/unread/:userSettings/"
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getEndpointUserSettings(): string {
		return this.configService.get((x) => x.common.content.oms?.endpoints!.userSettings, "v1/oms/usersettings/");
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getAlertPollingInterval(): number {
		return this.configService.get((x) => x.common.content.oms?.alertPollingInterval, fromMinutesToMilliseconds(10));
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getNotificationInfoPollingInterval(): number {
		return this.configService.get(
			(x) => x.common.content.oms?.notificationInfoPollingInterval,
			fromSecondsToMilliseconds(60)
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getNotificationInfoParams(): NotificationsInfoRequest {
		return this.configService.get((x) => x.common.content.oms?.notificationInfoParams, {
			popup: false,
			expired: false,
			hidden: false,
		}) as NotificationsInfoRequest;
	}
}
